/**
 * Scene facade — keeps Babylon.js out of the initial bundle.
 * Types are static; the heavy module loads on first createDoorpostScene().
 */

export type { ProbeSampleLike, ZoneId, SceneApi, Quality } from "./types";

export async function createDoorpostScene(
  container: HTMLElement,
  options: {
    onReady?: () => void;
    theme?: "light" | "dark";
    onZone?: (id: import("./types").ZoneId) => void;
  } = {},
): Promise<import("./types").SceneApi> {
  const mod = await import("./doorpost-scene");
  return mod.createDoorpostScene(container, options);
}
